import React from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { LuPlus } from 'react-icons/lu';
import Loading from '../../shared/components/Loading/Loading';
import { usePaymentLinksHistory } from './hooks/usePaymentLinksHistory';
import PaymentLinkTable from './components/PaymentLinkTable';
import './PaymentLinksPage.css';

/**
 * Tela "Venda Link" — histórico de links de pagamento já gerados na
 * Pagar.me. "Novo link" leva pra tela de venda (mesma seleção de produto
 * e frete de VendaBalcaoPage, mode="link") em vez de um formulário próprio
 * — usuário pediu explicitamente pra reusar aquele fluxo em vez de duplicar
 * a experiência de escolher produto.
 */
const PaymentLinksPage = () => {
  const history = useHistory();
  const { links, loading, error, sync, remove } = usePaymentLinksHistory();

  const handleSync = async (link) => {
    try {
      await sync(link._id);
      toast.success('Status ressincronizado com a Pagar.me.', { autoClose: 4000 });
    } catch (err) {
      toast.error('Não foi possível ressincronizar o link.', { autoClose: 4000 });
    }
  };

  const handleDelete = async (link) => {
    if (!window.confirm(`Excluir o link "${link.name}" do histórico?`)) return;
    try {
      await remove(link._id);
      toast.success('Link removido do histórico.', { autoClose: 4000 });
    } catch (err) {
      toast.error('Não foi possível excluir o link.', { autoClose: 4000 });
    }
  };

  return (
    <div>
      <ToastContainer />
      <div className="site-content">
        <div className="content-wrapper pt-6 pb-6">
          <Container fluid>
            <Row className="align-items-center mb-4">
              <Col>
                <h3 className="mb-0">Venda por Link</h3>
                <p className="text-muted mb-0">
                  Gere links de pagamento na Pagar.me pra até 3 produtos, com frete opcional.
                </p>
              </Col>
              <Col xs="auto">
                <button
                  type="button"
                  className="btn btn-primary d-flex align-items-center"
                  onClick={() => history.push('/admin-panel/payment-links/novo')}
                >
                  <LuPlus size={18} className="mr-1" />
                  Novo link
                </button>
              </Col>
            </Row>

            {error && (
              <Row className="mb-4">
                <Col>
                  <div className="alert alert-danger mb-0">
                    Não foi possível carregar o histórico de links. Tente novamente.
                  </div>
                </Col>
              </Row>
            )}

            <Row>
              <Col>
                <div className="payment-links-panel">
                  <PaymentLinkTable links={links} onSync={handleSync} onDelete={handleDelete} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {loading && <Loading overlay />}
      </div>
    </div>
  );
};

export default PaymentLinksPage;
